<app-workbench-page [breadcrumb]="breadcrumb">
    <app-information-panel
      [title]="'submitted_invoices_information_title' | translate"
      [description]="informationPanelDescription">
    </app-information-panel>

    <section class="cw-filters cw-grid-4" [attr.aria-label]="'submitted_invoices_filters' | translate">
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="brand-name">{{ "submitted_invoices_job_type" | translate }}</label>
        <select class="cw-field__control" id="brand-name" [(ngModel)]="filters.jobType">
          @for (jobType of jobTypes; track jobType) {
            <option [value]="jobType">{{ jobType }}</option>
          }
        </select>
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="job-number">{{ "submitted_invoices_job_number" | translate }}</label>
        <input class="cw-field__control" id="job-number" type="search" [(ngModel)]="filters.jobNumber"
               [placeholder]="'submitted_invoices_job_number_placeholder' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="site-name">{{ "submitted_invoices_site_name" | translate }}</label>
        <input class="cw-field__control" id="site-name" type="search" [(ngModel)]="filters.siteName"
               [placeholder]="'submitted_invoices_site_name' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="supplier-invoice-number">{{ "submitted_invoices_supplier_invoice_number" | translate }}</label>
        <input class="cw-field__control" id="supplier-invoice-number" type="search" [(ngModel)]="filters.vendorInvoiceNumber"
               [placeholder]="'submitted_invoices_invoice_ref_placeholder' | translate" />
      </div>
      <div class="cw-filters__item cw-card">
        <label class="cw-field__label" for="purchase-order-number">{{ "submitted_invoices_po_number" | translate }}</label>
        <input class="cw-field__control" id="purchase-order-number" type="search" [(ngModel)]="filters.purchaseOrderNumber"
               [placeholder]="'submitted_invoices_po_number' | translate" />
      </div>
    </section>
    <section class="cw-filters cw-grid-2" [attr.aria-label]="'submitted_invoices_filters' | translate">
      <button mat-raised-button type="button" class="apply-button" (click)="applyFilters()">
        <mat-icon>search</mat-icon>{{ "submitted_invoices_apply" | translate }}
      </button>
      <button mat-stroked-button type="button" class="reset-filter-button" (click)="resetFilters()">
        <mat-icon>restart_alt</mat-icon>{{ "submitted_invoices_reset_filters" | translate }}
      </button>
    </section>

    <mat-tab-group class="submitted-invoices-tabs" [selectedIndex]="selectedStatusIndex"
      (selectedIndexChange)="changeStatus(statuses[$event])"
      [attr.aria-label]="'submitted_invoices_status' | translate">
      @for (status of statuses; track status) {
        <mat-tab [label]="('submitted_invoices_tab_' + status.toLowerCase()) | translate" [aria-label]="('submitted_invoices_tab_' + status.toLowerCase()) | translate"></mat-tab>
      }
    </mat-tab-group>

    @if (hasLoadError) {
      <div class="cw-state cw-state--error cw-card" role="alert">{{ "submitted_invoices_load_error" | translate }}</div>
    } @else if (!hasLoaded) {
      <div role="status" [attr.aria-label]="'submitted_invoices_loading' | translate">
        <app-skeleton layout="table" [rows]="5" [columns]="showIposInvoiceNumber || showStatusColumn ? 7 : 6"></app-skeleton>
      </div>
    } @else if (invoices.length === 0) {
      <div class="cw-state cw-card" role="alert">{{ "submitted_invoices_empty" | translate }}</div>
    } @else {
      <section class="cw-table-card cw-card" [attr.aria-label]="'submitted_invoices_results' | translate">
        <div class="cw-table-card__scroll">
        <table class="cw-table" role="table">
          <thead role="rowgroup"><tr role="row">
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_job_type" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_job_number" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_site_name" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_po_numbers" | translate }}</th>
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_supplier_invoice_number" | translate }}</th>
            @if (showIposInvoiceNumber) {
              <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_ipos_invoice_number" | translate }}</th>
            }
            @if (showStatusColumn) {
              <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_status" | translate }}</th>
            }
            <th class="cw-table__head-cell" scope="col" role="columnheader">{{ "submitted_invoices_actions" | translate }}</th>
          </tr></thead>
          <tbody role="rowgroup">
            @for (invoice of invoices; track invoice.id) {
              <tr class="cw-table__row" role="row">
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_job_type' | translate" role="cell"><span>{{ invoice.jobType || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_job_number' | translate" role="cell">{{ invoice.jobReferenceNumber || '-' }}</td>
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_site_name' | translate" role="cell"><span>{{ invoice.siteName || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_po_numbers' | translate" role="cell"><span>{{ invoice.formattedPurchaseOrderNumber || '-' }}</span></td>
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_supplier_invoice_number' | translate" role="cell"><span>{{ invoice.vendorInvoiceNumber || '-' }}</span></td>
                @if (showIposInvoiceNumber) {
                  <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_ipos_invoice_number' | translate" role="cell"><span>{{ invoice.sourceSystemPurchaseInvoiceReferenceId || '-' }}</span></td>
                }
                @if (showStatusColumn) {
                  <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_status' | translate" role="cell"><span>{{ invoice.status || '-' }}</span></td>
                }
                <td class="cw-table__cell" [attr.data-label]="'submitted_invoices_actions' | translate" role="cell">
                  <span class="invoice-actions cw-grid-2">
                    <button mat-stroked-button class="button-size" type="button">{{ "submitted_invoices_edit" | translate }}</button>
                    <button mat-stroked-button class="button-size" type="button">{{ "submitted_invoices_view" | translate }}</button>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      </section>

    }
    @if (hasLoaded && !hasLoadError && totalCount > 0) {
      <br/>
      <mat-paginator [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons (page)="changePage($event)"></mat-paginator>
    }
</app-workbench-page>